import React, { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}
const FragmentWrapper: FC<Props> = ({ children }) => {
  return <>{children}</>;
};
export default FragmentWrapper;
